const documentChart = async ({ token, userID, isAdmin }) => {
  try {
    const response = await fetch(
      `https://lvdmsup.nablasol.net/DMS/api/get_document_uploded_data_specfic_user?userId=${userID}&isAdmin=${isAdmin}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default documentChart;
